import {acceptHMRUpdate, defineStore} from 'pinia';
import { i18n } from "@/plugins/i18n";
import filterHelper from '@nextories/vue-tasks/src/utils/helpers/common/filter';
import moversHelper from '@nextories/vue-tasks/src/utils/helpers/movers';
import projectsHelper from '@nextories/vue-tasks/src/utils/helpers/projects';
import { usePaginationStore } from '@nextories/vue-tasks/src/store/common/paginationStore';
import { usePartnersStore } from '@nextories/vue-tasks/src/store/partnersStore';
import { useUsersStore } from '@nextories/vue-tasks/src/store/usersStore';
import { useAuthStore } from '@nextories/vue-tasks/src/store/authStore';
import { paginationActions } from '@nextories/vue-tasks/src/store/common/common';
import { cloneWithoutReactivity } from "@nextories/vue-core-components/src/store/common";
import type { FilterQuery } from '@nextories/vue-tasks/src/types/Filters';

export const useSavStore = defineStore('sav', {
  state: () => {
    return {
      ...cloneWithoutReactivity(usePaginationStore().$state),
      queryDefault: {
        dispute_status: true,
        dispute: true,
      },
      pageSize: 10,
      storageCustomFilters: '_sav_custom_filters',
      baseMainFilters: JSON.parse(JSON.stringify(i18n.global.tm('filters.mainSavProjectFilters'))) || {},
    };
  },
  actions: {
    ...paginationActions,
    useUsersStore() {
      return useUsersStore();
    },
    useAuthStore() {
      return useAuthStore();
    },
    setInitialFilters(query?: FilterQuery) {
      const { baseMainFilters } = this;
      const partnerAccount = usePartnersStore().listPartnerAccount;
      const filterUsersCoord = useUsersStore().filterUsersCoord;
      const disputeFilter = projectsHelper.formatDisputeFilter();
      // Construct subFilters directly
      const subFilters = {
        ...cloneWithoutReactivity(filterUsersCoord),
        ...cloneWithoutReactivity(partnerAccount?.length ? projectsHelper.formatPartnerAccountFilter(partnerAccount) : {}),
        ...cloneWithoutReactivity(moversHelper.moversFilter()),
        ...cloneWithoutReactivity(filterHelper.formatDatesFilter('loadingDate', 'final_dep_date')),
        ...cloneWithoutReactivity(filterHelper.formatDatesFilter('deliveryDate', 'final_arr_date')),
        ...cloneWithoutReactivity(disputeFilter),
        ...filterHelper.setSubFiltersEnabled('dispute_status', ['dispute_status'], disputeFilter, query),
        ...cloneWithoutReactivity(projectsHelper.nbTasksFilter()),
      };
      // Set dispute filter settings
      baseMainFilters.dispute = {
        ...baseMainFilters.dispute,
        ...this.mainSettings,
        id: 'dispute',
        query: {},
        type: 'main-enabled',
        queries: {
          get: this.queryDefault,
        },
        icon: 'list',
        enabled: true,
        isAuto: true,
        subFilters,
      };
      this.baseMainFilters = baseMainFilters;
      // Apply filters
      this.setMainFilters(cloneWithoutReactivity(baseMainFilters));
      this.setActivatedFilter(this.mainFilters.dispute);
    },
    getItems(request) {
      this.setLoading(true);
      const {timeoutId} = this;
      return window.connector
        .getDisputes(request)
        .then(async (result) => {
          if (!timeoutId || timeoutId === this.timeoutId) {
            this.setCurrentPage(request.page_number);
            this.setItems(Object.values(projectsHelper
              .formatProjects(result.id_dgts, useUsersStore().users)));
            this.filterItems();
            this.setTotalResult(result.num_result);
            this.setTotalPages(result.num_pages);
            this.setError(false);
            this.setIsError(false);
          }
        })
        .catch((error) => {
          this.setError(true);
          this.setIsError(true);
          throw new Error(error);
        })
        .finally(() => {
          if (!timeoutId || this.timeoutId === timeoutId) {
            this.setLoading(false);
          }
        });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSavStore, import.meta.hot))
}
